import React from 'react';

/**
 * Hides the docs site name (usually the repository name) that mkdocs-material
 * renders above the file tree in the left navigation. Content addons are
 * rendered inside the TechDocs shadow root, so this style applies to the page.
 */
export const HideNavSiteTitle = () => (
  <style>{`
    .md-nav--primary > .md-nav__title {
      display: none !important;
    }
  `}</style>
);
